/* Fathom Thread v1: header (menu, tìm kiếm có gợi ý) + giữ link trong template mới khi xem bản nháp. */
(function () {
  'use strict';
  if (window.FtLayout) return;
  window.FtLayout = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function money(v) { var n = typeof v === 'string' ? parseFloat(v) : v / 100; try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: CUR }).format(n); } catch (e) { return '$' + n.toFixed(2); } }
  function el(tag, attrs, kids) { var n = document.createElement(tag); Object.keys(attrs || {}).forEach(function (k) { if (k === 'text') n.textContent = attrs[k]; else n.setAttribute(k, attrs[k]); }); (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); }); return n; }

  function init() {
    var h = document.querySelector('[data-fth]'); if (!h || h.hasAttribute('data-fth-ready')) return;
    h.setAttribute('data-fth-ready', '1');
    var sheets = { menu: h.querySelector('[data-fth-sheet="menu"]'), search: h.querySelector('[data-fth-sheet="search"]') };
    var bar = h.querySelector('[data-fth-sticky]') || h.querySelector('.fth__bar');
    /* chiều cao khối header dính → --ft-stick (cuộn tới neo, cột dính của trang SP/giỏ) */
    if (bar) {
      var setStick = function () { document.documentElement.style.setProperty('--ft-stick', Math.round(bar.getBoundingClientRect().height) + 'px'); };
      setStick(); if (window.ResizeObserver) new ResizeObserver(setStick).observe(bar); else window.addEventListener('resize', setStick);
    }
    h.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fth-open]'); if (!b) return;
      var what = b.getAttribute('data-fth-open');
      if (what === 'search' && !sheets.menu.hidden) window.FtSheet.close(sheets.menu);
      /* desktop: ô gợi ý neo ngay dưới thanh chính, dù đang ở đầu trang hay đã cuộn */
      if (what === 'search' && bar) sheets.search.style.setProperty('--fth-s-top', Math.max(0, Math.round(bar.getBoundingClientRect().bottom)) + 'px');
      closeNav();
      window.FtSheet.open(sheets[what], b);
    });

    /* ----- menu lớn / menu con desktop: nút mở (click, Enter, Space), rê chuột, Escape, bấm ra ngoài ----- */
    var navItems = [].slice.call(h.querySelectorAll('.fth__navitem.has-mega, .fth__navitem.has-dd'));
    var hoverTimer = null;
    function setOpen(li, on) {
      li.classList.toggle('is-open', on);
      var btn = li.querySelector('[data-fth-mega-btn],[data-fth-dd-btn]'); if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function closeNav(except) { navItems.forEach(function (li) { if (li !== except) { setOpen(li, false); li.classList.remove('is-hover'); } }); }
    navItems.forEach(function (li) {
      var btn = li.querySelector('[data-fth-mega-btn],[data-fth-dd-btn]'); if (!btn) return;
      btn.addEventListener('click', function () { var on = !li.classList.contains('is-open'); closeNav(li); setOpen(li, on); });
      li.addEventListener('mouseenter', function () { if (!window.matchMedia('(hover: hover)').matches) return; clearTimeout(hoverTimer); hoverTimer = setTimeout(function () { closeNav(li); li.classList.add('is-hover'); btn.setAttribute('aria-expanded', 'true'); }, 120); });
      li.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); hoverTimer = setTimeout(function () { li.classList.remove('is-hover'); if (!li.classList.contains('is-open')) btn.setAttribute('aria-expanded', 'false'); }, 180); });
      li.addEventListener('focusout', function (e) { if (e.relatedTarget && !li.contains(e.relatedTarget)) { setOpen(li, false); li.classList.remove('is-hover'); } });
      li.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (li.classList.contains('is-open') || li.classList.contains('is-hover')) { e.preventDefault(); setOpen(li, false); li.classList.remove('is-hover'); btn.focus(); }
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.fth__navitem')) closeNav(); });

    /* ----- điều kiện giảm giá bộ: một sheet trong header, mở từ thanh trên cùng, trang sản phẩm, giỏ ----- */
    var offerSheet = h.querySelector('[data-ft-offer-sheet]');
    if (offerSheet) document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ft-offer-open]'); if (!b) return;
      e.preventDefault(); closeNav(); window.FtSheet.open(offerSheet, b);
    });

    /* ----- gợi ý tìm kiếm ----- */
    var q = h.querySelector('[data-fth-q]'), idle = h.querySelector('[data-fth-idle]'), live = h.querySelector('[data-fth-live]');
    var box = h.querySelector('[data-fth-sugg]'), status = h.querySelector('[data-fth-status]'), clear = h.querySelector('[data-fth-clear]');
    var title = h.querySelector('[data-fth-s-title]'), form = h.querySelector('[data-fth-s-form]');
    var view = h.getAttribute('data-preview-view') || '';
    var timer = null, ctrl = null, seq = 0, composing = false;
    function searchUrl(term) { return ROOT + 'search?type=product&q=' + encodeURIComponent(term) + (view ? '&view=' + encodeURIComponent(view) : ''); }
    function reset() { live.hidden = true; idle.hidden = false; title.hidden = false; box.innerHTML = ''; status.textContent = ''; q.setAttribute('aria-expanded', 'false'); clear.hidden = !q.value; }
    function options() { return [].slice.call(box.querySelectorAll('[role="option"]')); }
    function render(term, data) {
      box.innerHTML = '';
      var res = (data && data.resources && data.resources.results) || {};
      var qs = res.queries || [], cols = res.collections || [], ps = res.products || [];
      qs.slice(0, 3).forEach(function (x) {
        box.appendChild(el('a', { class: 'fth-sugg__q', role: 'option', href: searchUrl(x.text), id: 'fth-o-' + Math.random().toString(36).slice(2) }, [el('span', { 'aria-hidden': 'true', text: '⌕' }), x.text]));
      });
      if (cols.length) {
        box.appendChild(el('h3', { text: 'Collections' }));
        cols.slice(0, 3).forEach(function (c, i) {
          box.appendChild(el('a', { class: 'fth-sugg__q fth-sugg__col', role: 'option', href: c.url, id: 'fth-oc' + i }, [el('span', { 'aria-hidden': 'true', text: '▦' }), c.title, el('i', { 'aria-hidden': 'true', text: '›' })]));
        });
      }
      if (ps.length) {
        box.appendChild(el('h3', { text: 'Products' }));
        ps.slice(0, 6).forEach(function (p, i) {
          var im = p.featured_image && p.featured_image.url;
          box.appendChild(el('a', { class: 'fth-sugg__p', role: 'option', href: p.url, id: 'fth-op' + i }, [
            im ? el('img', { src: im + (im.indexOf('?') > -1 ? '&' : '?') + 'width=200', alt: '', width: '72', height: '72' }) : el('span'),
            el('span', {}, [el('b', { text: p.title }), el('span', { text: p.type || '' }), el('strong', { text: (p.price_max && p.price_min && p.price_max !== p.price_min ? 'From ' : '') + money(p.price_min || p.price) })]),
            el('span', { 'aria-hidden': 'true', text: '›' })
          ]));
        });
      }
      if (!qs.length && !cols.length && !ps.length) status.textContent = 'No quick matches. Press Search to see all results.';
      else box.appendChild(el('a', { class: 'fth-sugg__all', href: searchUrl(term), text: 'View all results for “' + term + '” →' }));
      live.hidden = false; idle.hidden = true; title.hidden = true; q.setAttribute('aria-expanded', 'true');
    }
    function suggest() {
      var term = q.value.trim(); clear.hidden = !q.value;
      if (term.length < 2) { if (ctrl) ctrl.abort(); reset(); return; }
      if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
      var my = ++seq; status.textContent = 'Searching…'; live.hidden = false;
      var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=query,collection,product&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('bad'); return r.json(); })
        .then(function (d) { if (my !== seq || sheets.search.hidden) return; status.textContent = ''; render(term, d); })
        .catch(function (x) {
          if (x && x.name === 'AbortError') return; if (my !== seq) return;
          box.innerHTML = ''; status.textContent = "We couldn't load suggestions. ";
          status.appendChild(el('a', { href: searchUrl(term), text: 'Search all results' }));
        });
    }
    q.addEventListener('compositionstart', function () { composing = true; });
    q.addEventListener('compositionend', function () { composing = false; clearTimeout(timer); timer = setTimeout(suggest, 250); });
    q.addEventListener('input', function () { if (composing) return; clearTimeout(timer); timer = setTimeout(suggest, 250); });
    q.addEventListener('keydown', function (e) {
      if (e.isComposing) return;
      var o = options(); if (!o.length) return;
      var i = o.findIndex(function (x) { return x.getAttribute('aria-selected') === 'true'; });
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        i = e.key === 'ArrowDown' ? (i + 1) % o.length : (i <= 0 ? o.length - 1 : i - 1);
        o.forEach(function (x, k) { x.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        q.setAttribute('aria-activedescendant', o[i].id); o[i].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && i > -1) { e.preventDefault(); location.href = o[i].href; }
    });
    clear.addEventListener('click', function () { q.value = ''; if (ctrl) ctrl.abort(); reset(); q.focus(); });
    form.addEventListener('submit', function (e) { if (!q.value.trim()) { e.preventDefault(); q.focus(); } });
    sheets.search.addEventListener('ft:close', function () { if (ctrl) ctrl.abort(); clearTimeout(timer); });

    /* ----- xem bản nháp: giữ link trong template mới (chỉ khi header có preview_view) ----- */
    if (view) {
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href]'); if (!a || a.target === '_blank') return;
        var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
        if (u.origin !== location.origin || u.searchParams.has('view')) return;
        if (!/^\/(products\/|collections\/|cart\/?$|search\/?$|$)/.test(u.pathname)) return;
        u.searchParams.set('view', view); a.href = u.toString();
      }, true);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
